/**
 * Converts an MSAL account info object to a unified user DTO.
 *
 * @param {Object} msalAccount - MSAL account info from getActiveAccount()
 * @param {string} [msalAccount.username] - User's email address
 * @param {string} [msalAccount.localAccountId] - User's unique ID
 * @param {string} [msalAccount.name] - User's full name
 * @param {Object} [msalAccount.idTokenClaims] - Claims from ID token
 * @returns {Object} User DTO with userId, emailAddress, name, firstName, lastName
 */
export function getUserDtoFromMsalAccountInfo(msalAccount) {
    const emailAddress = msalAccount.username
        ? msalAccount.username
        : msalAccount.idTokenClaims?.emails
          ? msalAccount.idTokenClaims?.emails[0]
          : undefined
    const lastName = msalAccount.idTokenClaims?.family_name
    const firstName = msalAccount.idTokenClaims?.given_name
    const userId = msalAccount.localAccountId
    const name = msalAccount.name

    return {
        userId,
        emailAddress,
        name,
        firstName,
        lastName,
    }
}

/**
 * Converts a Kinde user object to a unified user DTO.
 *
 * @param {Object} kindeUser - Kinde user object from useKindeAuth()
 * @param {string} [kindeUser.id] - User's Kinde ID (format: 'kp_xxx')
 * @param {string} [kindeUser.email] - User's email address
 * @param {string} [kindeUser.preferredEmail] - User's preferred email (fallback)
 * @param {string} [kindeUser.givenName] - User's first name
 * @param {string} [kindeUser.familyName] - User's last name
 * @returns {Object} User DTO with userId, emailAddress, name, firstName, lastName
 */
export function getUserDtoFromKindeUser(kindeUser) {
    const firstName = kindeUser?.givenName
    const lastName = kindeUser?.familyName
    const name = [firstName, lastName].filter(Boolean).join(' ') || undefined

    return {
        userId: kindeUser?.id,
        emailAddress: kindeUser?.email || kindeUser?.preferredEmail,
        name,
        firstName,
        lastName,
    }
}
